<template>
	<div>
		<v-dialog v-model="particular" no-click-animation persistent scrollable content-class="full-height" lazy transition="dialog-bottom-transition">
	        <v-card>

		        <v-card-text full-height nopadding>
		            <v-layout wrap>
		            	<v-form data-vv-scope="fields" full-width>
				            
		            		<div class="middle-tabs">

		            			<v-list nopadding full-width>
	            					<v-list-tile class="custom-avatar-tile">
	            						<v-list-tile-content>
	            						 	<!-- <v-list-tile-title>{{$parent.Form.particularsData.amountType ? 'To' : 'From'}}</v-list-tile-title> -->
											 <v-list-tile-title>{{$parent.Form.particularsData.amountType ? 'By (Dr)' : 'To (Cr)'}}</v-list-tile-title>
	            						</v-list-tile-content>
	            					</v-list-tile>	
	            				</v-list>

	            				<v-divider></v-divider>

		            			<v-layout row wrap>

		            				<!-- <v-flex xs12 sm12 md12 mb-3 class="custom-radio-buttons">
		            					<v-radio-group row height="24" v-model="$parent.Form.particularsData.amountType" hide-messages @change="fn_changeNature(true)">
		            						// selectedNatureValue debit/to first
		            						<template v-if="$parent.selectedNatureValue">
		            							<v-radio :label="$parent.Form.defaultView ? 'Debit' : 'To'" :value="1" color="#666" 
				                        		:class="{'activeNature':$parent.Form.particularsData.amountType}"></v-radio>
							                    <v-radio :label="$parent.Form.defaultView ? 'Credit' : 'From'" :value="0" color="#666"
							                    	:class="{'activeNature':!$parent.Form.particularsData.amountType}"></v-radio>	
		            						</template>
		            						// selectedNatureValue credit/from first
		            						<template v-else>
		            							<v-radio :label="$parent.Form.defaultView ? 'Credit' : 'From'" :value="0" color="#666"
							                    	:class="{'activeNature':!$parent.Form.particularsData.amountType}"></v-radio>
		            							<v-radio :label="$parent.Form.defaultView ? 'Debit' : 'To'" :value="1" color="#666" 
				                        		:class="{'activeNature':$parent.Form.particularsData.amountType}"></v-radio>
		            						</template>
						                </v-radio-group>
				                    </v-flex> -->

							        <v-flex xs12 sm12 md12 form-item align-msg-right @click="$parent.fn_openAccountLedgers('android', 'AccountLedgers', 'field_accountGroups')" style="margin-top: 16px;">
							        	<v-text-field  
							        		readonly
							        		:hide-details="$parent.Form.particularsData.accountLedgerName ? true : false"
						               		v-model="$parent.Form.particularsData.accountLedgerName" 
						               		label="Ledger" 
						               		placeholder=" "
						               		append-icon="arrow_drop_down"
						               		ref="field_accountGroups" 
							               	:onUpdate="$parent.fn_updateAccountLedger"
							               	v-validate="'required'" 
						               		data-vv-name="accountLedger" 
						               		data-vv-as="account ledger" 
						               		:error-messages="errors.collect('fields.accountLedger')">
						               	</v-text-field>
						            </v-flex>

						            <v-flex right-align xs12 sm12 md12 pl-3 pr-3 pb-2 pt-1 font12 v-if="$parent.Form.particularsData.accountLedgerName">
						               <!-- <span light-opacity-color>Balance:</span> -->
									   <span light-opacity-color>{{ $parent.fn_balanceLabel($parent.Form.partyDetails) }}</span>
						               <span :class="[$parent.Form.particularsData.currentBalance < 0 ? 'redcolor' : 'greencolor']">&#8377; {{$parent.Form.particularsData.currentBalance}}</span>
									   <!-- <span :class="[$parent.Form.particularsData.currentBalance < 0 ? 'redcolor' : 'greencolor']">&#8377; {{$parent.fn_processedBalance($parent.Form.particularsData.currentBalance, $parent.Form.particularsData.currentBalanceType)}}</span> -->
						            </v-flex>

						             <v-flex xs12 sm12 md12 form-item>
						               <v-text-field 
						               		id="amount_field" 
						               		v-model.number="$parent.Form.particularsData.amount" 
						               		@input="adjustOnAccount"
						               		type="number" 
						               		label="Amount" 
						               		placeholder=" "
						               		v-validate="'required|min_value:0|decimal:2'" 
						               		data-vv-name="onaccount" 
						               		data-vv-as="on account" 
						               		:error-messages="errors.collect('fields.onaccount')">
						               	</v-text-field>
						            </v-flex>

						            <!-- <v-list class="full-width" nopadding v-if="isReferenceVisible($parent.Form.particularsData.amountType)">

						              <v-list-tile v-if="!$parent.hasAgainstReference">
						                <v-list-tile-content>
						                  <v-list-tile-title style="color:#1976d2;font-size:13px;">
						                  	<div style="display: inline;padding: 16px 16px 16px 0px;" @click="loadReferences">AGAINST INVOICE</div>
						                  </v-list-tile-title>
						                </v-list-tile-content>
						              </v-list-tile>

						              <v-list-tile v-if="$parent.Form.particularsData.onAccount">
						                <v-list-tile-content>
						                  	<v-list-tile-title>On Account</v-list-tile-title>
						                </v-list-tile-content>
						                <v-list-tile-action>&#8377; {{$parent.Form.particularsData.onAccount}}</v-list-tile-action>
						              </v-list-tile>

						               <v-list-tile v-for="(ref, index) in $parent.Form.particularsData.references" :key="index" v-if="ref.amount" class="oneline-tile-dense">

						                <v-list-tile-content>
						                  	<v-list-tile-title>
						                  		<span v-if="ref.baseTransactionNumber">{{ref.baseTransactionNumber}}</span>
						                  		<span v-else>{{ref.baseRefNumber ? ref.baseRefNumber : ''}}</span>
						                  	</v-list-tile-title>
						                  
						                </v-list-tile-content>

						                <v-list-tile-action>&#8377; {{ref.amount}}</v-list-tile-action>
						              </v-list-tile>
						            </v-list> -->

						            <v-expansion-panel flat v-if="$parent.Form.particularsData.acRefDetails">

									    <v-expansion-panel-content class="noborder">
									      	<div slot="header">Other Details</div>
									      
									      	<v-layout row wrap>
							            	  	<v-flex xs12 sm12 md12 form-item>
									               <v-text-field  label="Bank Name" placeholder=" " v-model="$parent.Form.particularsData.bankName"></v-text-field>
									            </v-flex>

									            <v-flex xs12 sm12 md12 form-item @click="$parent.fn_openDialogWeb('web', 'AgainstReference', 'ref_bankTransactionTypes')">

										            <v-text-field  
									               		readonly 
									               		v-model="$parent.Form.particularsData.transType"
									               		label="Type" 
									               		placeholder=" "
									               		append-icon="arrow_drop_down">
										            </v-text-field>
										        </v-flex>

										        <v-flex xs12 sm12 md12 form-item>
									               <v-text-field  label="Reference Number" placeholder=" " v-model="$parent.Form.particularsData.refNumber"></v-text-field>
									            </v-flex>

									            <v-list class="full-width" nopadding>
												  	<v-list-tile>
											          	<v-list-tile-content>
											              <v-list-tile-title>Dated</v-list-tile-title>
											            </v-list-tile-content>

											            <span v-if="$parent.Form.particularsData.refDate">{{$parent.Form.particularsData.refDate | moment("DD-MMM-YYYY")}}</span>

											            <!-- <span v-else>{{$parent.Form.tempRefDate | moment("DD-MMM-YYYY")}}</span> -->

											            <v-list-tile-action class="action-small">
								            				<v-btn flat icon color="primary" @click="openDatePicker('other', $parent.Form.particularsData.refDate ? $parent.Form.particularsData.refDate : new Date())" style="margin-left:0">
								            					<v-icon>date_range</v-icon>	
								            				</v-btn>
											            </v-list-tile-action>
												    </v-list-tile>
												</v-list>
							            	</v-layout>
									    </v-expansion-panel-content>
									</v-expansion-panel>
								</v-layout>

							</div>

			            </v-form>

		            </v-layout>
		        </v-card-text>
		        <v-divider></v-divider>
		        <v-card-actions>
		        	<v-spacer></v-spacer>
          			<v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">close</v-btn>
		          	<v-btn small color="blue darken-1" flat :disabled="disableBtn" @click="fn_saveDetails">ok</v-btn>
		        </v-card-actions>
		    </v-card>

		    

	    </v-dialog>
	</div>
</template>

<script>

export default{
	props:['openDatePicker', 'saveParticulars', 'loadReferences', 'isReferenceVisible', 'adjustOnAccount', 'checkReferenceTotal'],
	data(){
		return{
			particular:false,
			disableBtn:false
		}
	},
	methods:{
		openDialogWeb: function () {
			this.particular = true;
		},
		closeDialogWeb: function () {
			this.particular = false;
		},
	    fn_changeNature: function (clearDetails) {

	    	//clearing fields on change
	    	
	    	if(clearDetails && this.$parent.toolbarTitle !='Journal'){

	    		let editEntry = false;

	    		this.$parent.Form.particularsData.groupId = null;
	    		this.$parent.Form.particularsData.accountLedgerId = null;
	    		this.$parent.Form.particularsData.accountLedgerName = null;
	    		this.$parent.Form.particularsData.amount = null;
	    		this.$parent.Form.particularsData.currentBalance = null;
	    		this.$parent.Form.particularsData.currentBalanceType = null;
	    		this.$parent.Form.particularsData.references = [];

				//Checking if first/default entry already exist

				let itemIndex = this.$parent.Form.filteredItems.findIndex(item=>{
					return item.amountType == this.$parent.selectedNatureValue;
				});

				if(this.$parent.Form.particularsData.amountType == this.$parent.selectedNatureValue && itemIndex!=-1){
					editEntry = true;
					this.$parent.fn_editEntry(this.$parent.Form.filteredItems[itemIndex], false);
				}
				//appending remaining balance to other side
				else{
					if(this.$parent.Form.particularsData.amountType==1 && this.$parent.debitTotal < this.$parent.creditTotal){
		    			this.$parent.Form.particularsData.amount = this.$parent.creditTotal - this.$parent.debitTotal;
			    	}
			    	else if(this.$parent.Form.particularsData.amountType==0 && this.$parent.debitTotal > this.$parent.creditTotal){
			    		this.$parent.Form.particularsData.amount = this.$parent.debitTotal - this.$parent.creditTotal;
			    	}
				}
				
	    		
	    		if(!editEntry){
	    			this.$parent.fn_openAccountLedgers('android', 'AccountLedgers', 'field_accountLedgers');
	    		}
	    	}
	    },

	    fn_saveDetails: function () {
	    	this.disableBtn = true;
	    	this.$validator.validateAll('fields').then((result) => {
		        if (result) {

		        	if(this.$parent.Form.particularsData.amountType != this.$parent.selectedNatureValue){
			    		if(!this.$parent.Form.particularsData.amount){
			    // 			this.$parent.snackbar = true;
							// this.$parent.snackbar_msg = "Enter a valid amount.";
							this.showToast("Enter a valid amount");
							this.disableBtn = false;
							return;
			    		}
			    	}
			    	else{
						if(!this.$parent.Form.particularsData.amount && !this.$parent.Form.particularsData.references.length){
							// this.$parent.snackbar = true;
							// this.$parent.snackbar_msg = "Enter a valid amount or add a reference.";
							this.showToast("Enter a valid amount or add a reference");
							this.disableBtn = false;
							return;
						}	    		
			    	}

		           	this.saveParticulars(this.$parent.Form.particularsData);
		        }
		        else{
		        	this.disableBtn = false;
		        }
		    });
		},
		
		fn_calculateTotalAmount: function (items) {
			let totalAmount = 0;
			for(let i=0;i<items.length;i++){
				totalAmount += items[i].accountLedger.amount;
			}
			return totalAmount;
		},

		// fn_removeReference: function(index){
		// 	this.$parent.Form.particularsData.references.splice(index, 1);
		// 	this.fn_calculateReferenceTotal();
		// },

		// fn_removeOnAccount: function(){
		// 	this.$parent.Form.particularsData.onAccount = null;
		// 	this.fn_calculateReferenceTotal();
		// },

		fn_calculateReferenceTotal: function(){
			let referenceTotal = 0;
			for(let i in this.$parent.Form.particularsData.references){
				referenceTotal += this.$parent.Form.particularsData.references[i].amount;
			}

			let onAccount = this.$parent.Form.particularsData.onAccount ? this.$parent.Form.particularsData.onAccount : 0
			this.$parent.Form.particularsData.amount = referenceTotal || onAccount ? this.roundUpto2Decimals(referenceTotal + onAccount) : null;
		},

		// fn_isAmountDisabled: function(){
		// 	if(!this.$parent.Form.particularsData.onAccount && !this.$parent.Form.particularsData.references.length){
		// 		return false;
		// 	}
		// 	else{
		// 		return true;
		// 	}
		// }
		
	}
}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/accountbooks/dialogs/dialog_add_particular.vue